import { render, staticRenderFns } from "./applet.vue?vue&type=template&id=19aa90e9&scoped=true"
import script from "./applet.vue?vue&type=script&lang=js"
export * from "./applet.vue?vue&type=script&lang=js"
import style0 from "./applet.vue?vue&type=style&index=0&id=19aa90e9&lang=scss"
import style1 from "./applet.vue?vue&type=style&index=1&id=19aa90e9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa90e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19aa90e9')) {
      api.createRecord('19aa90e9', component.options)
    } else {
      api.reload('19aa90e9', component.options)
    }
    module.hot.accept("./applet.vue?vue&type=template&id=19aa90e9&scoped=true", function () {
      api.rerender('19aa90e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platList/applet.vue"
export default component.exports